var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45642 0.292894C6.08049 -0.0976304 5.47099 -0.0976303 5.09506 0.292894L0.281944 5.29289C-0.0939829 5.68342 -0.0939829 6.31658 0.281944 6.70711L5.09506 11.7071C5.47099 12.0976 6.08049 12.0976 6.45642 11.7071C6.83235 11.3166 6.83235 10.6834 6.45642 10.2929L3.2866 7L13.9993 7L14 6L13.9993 5L3.2866 5L6.45642 1.70711C6.83235 1.31658 6.83235 0.683418 6.45642 0.292894Z",
    fill: "#1953FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "react/media/arrow-back.0457a35f3673461254c772ab327cdbf0.svg";
export { ForwardRef as ReactComponent };